export default __webpack_public_path__ + "static/media/10l-inact.bfadeaac.svg";